import {
  parseNativePartyPassCheckoutContext,
  type NativePartyPassCheckoutContext,
} from "@award-party/shared";

interface NativeCheckoutMessageBridge {
  postMessage(message: string): void;
}

interface NativeCheckoutGlobal {
  AwardPartyNative?: unknown;
  ReactNativeWebView?: NativeCheckoutMessageBridge;
}

export function getNativePartyPassCheckoutContext():
  | NativePartyPassCheckoutContext
  | undefined {
  return parseNativePartyPassCheckoutContext(
    (globalThis as NativeCheckoutGlobal).AwardPartyNative,
  );
}

export function openNativePartyPassCheckout(url: string): boolean {
  return postNativeMessage({
    type: "award-party:open-external-checkout",
    url,
  });
}

export function requestNativePartyPassIap(partyId: string): boolean {
  return postNativeMessage({
    type: "award-party:request-iap",
    partyId,
  });
}

export function finishNativePartyPassIap(): boolean {
  return postNativeMessage({ type: "award-party:finish-iap" });
}

export function restoreNativePartyPassIap(): boolean {
  return postNativeMessage({ type: "award-party:restore-iap" });
}

function postNativeMessage(message: Record<string, string>): boolean {
  const bridge = (globalThis as NativeCheckoutGlobal).ReactNativeWebView;
  if (!bridge?.postMessage) {
    return false;
  }

  bridge.postMessage(JSON.stringify(message));
  return true;
}
